import { render, staticRenderFns } from "./asyncTextblock.vue?vue&type=template&id=1371a5cb&scoped=true&"
import script from "./asyncTextblock.vue?vue&type=script&lang=js&"
export * from "./asyncTextblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371a5cb",
  null
  
)

export default component.exports